module.exports = __webpack_public_path__ + "static/img/banner2.3442def.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/homepage/images/banner2.png
// module id = 3osU
// module chunks = 1